export const TEXTS = {
  ACCEPTANCE_ADVANCED_ERROR: 'Ошибка при подписании Согласия на списание. Повторите попытку',
  ACCEPTANCE_ADVANCED_CREATED: 'Процесс подписания Согласия на списания запущен. Пройдите в Личный кабинет СберБизнес',
  ACCEPTANCE_ADVANCED_PENDING: 'Проверяем статус подписания Согласия на списание. Ожидайте',
  ACCEPTANCE_ADVANCED_TOO_LONG:
    'Статус согласия на списание средств все еще неактивен. Проверьте состояние подписки в личном кабинете СберБанк Бизнес',
  ACCEPTANCE_ADVANCED_CANCELLED: 'Согласие на списание средств отменено. Подпишите заново',
  ACCEPTANCE_ADVANCED_ACTIVE_TRIAL:
    'Согласие подписано. Необходимая сумма будет списываться автоматически по завершению тестового периода',
  ACCEPTANCE_ADVANCED_ACTIVE: 'Согласие подписано. Необходимая сумма будет списываться автоматически',
  ACCEPTANCE_ADVANCED_TAB_CLOSED:
    'Похоже, вы закрыли вкладку браузера с подписанием согласие. Запустите процесс подписания заново',
  ACCEPTANCE_ADVANCED_TOO_MANY_ATTEMPTS:
    'Превышено количество попыток получить актуальный статус подписания. Запустите процесс подписания заново',
};
